/**
 * Issues de validation-coordonnees (parité mobile, useSouscrireEnLigneCoordonneesCheck).
 * Les chaînes citées sont les messages SEL, repris tels quels pour garder le mapping traçable.
 * - `VALID` : 200 `valide: true`, coordonnées utilisables (et code envoyé sur le parcours email) ;
 * - `ALREADY_USED` : 200 `valide: false` (« Coordonnees utilise ») ;
 * - `SEND_FAILED` : 404 (« Envoi verif coordonnees ko ») ;
 * - `MISSING_CONTACT_DETAILS` : 401 (« Pas de coordonnees ») ;
 * - `CODE_SEND_FAILED` : 404 « Envoi token temp ko », propre au web : l'envoi du code a échoué ;
 * - `ERROR` : tout le reste (réseau, 5xx…), non couvert par le back.
 */
enum COORDONNEES_CHECK_STATUS {
  VALID = 'valid',
  ALREADY_USED = 'alreadyUsed',
  SEND_FAILED = 'sendFailed',
  MISSING_CONTACT_DETAILS = 'missingContactDetails',
  CODE_SEND_FAILED = 'codeSendFailed',
  ERROR = 'error',
}

enum COORDONNEES_CHECK_CHANNEL {
  EMAIL = 'email',
  TELEPHONE = 'telephone',
}

export { COORDONNEES_CHECK_CHANNEL, COORDONNEES_CHECK_STATUS };
